// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // firebaseConfig : {
  //   apiKey: "AIzaSyAQUykio0YOnGP_oBRAZvfmqFk3h4WzCgE",
  //   authDomain: "melo2db.firebaseapp.com",
  //   databaseURL: "https://melo2db.firebaseio.com",
  //   projectId: "melo2db",
  //   storageBucket: "melo2db.appspot.com",
  //   messagingSenderId: "730337457648",
  //   appId: "1:730337457648:web:551854ed5eed3c7d339935"
  // }
  firebaseConfig: {
    apiKey: "AIzaSyBQQaIMBcjVc1f7OKDn0hy-eKUPGdT4pw4",
    authDomain: "homemadefarmchanthaburi.firebaseapp.com",
    databaseURL: "https://homemadefarmchanthaburi.firebaseio.com",
    projectId: "homemadefarmchanthaburi",
    storageBucket: "homemadefarmchanthaburi.appspot.com",
    messagingSenderId: "110175057637",
    appId: "1:110175057637:web:082d25178eb3a05e03c60c",
    measurementId: "G-ER0GBBCZZE",

    clientId:
      "110175057637-rsgb93qgn8dnrobjbl05hmp78bidk71j.apps.googleusercontent.com",
    discoveryDocs: [
      "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
    ],
    scope: ["https://www.googleapis.com/auth/calendar"],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
